/**
 * WHAT THE PERSON HAS OPEN, as a phrase the chat is given with each message:
 * "the 'Tools' table, narrowed to type: standalone analytics". The chat only
 * ever saw the words typed, so "make the opposite of this" had no "this".
 * Pure, so jest can pin it.
 */
import { parseTag } from './filters';

const KIND_WORDS: Record<string, string> = {
  COMPANY: 'company',
  PRODUCT: 'product',
  SOLUTION_TYPE: 'solution type',
  FEATURE: 'feature',
  PAIN: 'pain',
  IDEA: 'idea',
  PRICING: 'pricing plan',
  EVIDENCE: 'piece of evidence',
  QUESTION: 'question',
};

export interface ViewState {
  stage: 'board' | 'reports' | 'feed' | 'profile';
  /** The table on screen, by the room's own name for it. */
  table?: string | null;
  /** The item whose page is open. */
  profile?: { id: number; kind: string; title: string } | null;
  /** The card open on the board. */
  boardCard?: string | null;
  tags?: string[];
  verified?: string | null;
  sourced?: string | null;
  /** The author lens, by name. */
  by?: string | null;
  /** An item open in the side panel. */
  drawer?: { id: number; kind: string; title: string } | null;
}

function item(x: { id: number; kind: string; title: string }): string {
  return `the ${KIND_WORDS[x.kind] ?? x.kind.toLowerCase()} "${x.title}" (#${x.id})`;
}

export function viewPhrase(v: ViewState): string | null {
  let where: string | null = null;
  if (v.stage === 'profile' && v.profile) where = `the page for ${item(v.profile)}`;
  else if (v.stage === 'reports' && v.table) where = `the "${v.table}" table`;
  else if (v.stage === 'board') where = v.boardCard ? `the board, with the "${v.boardCard}" card open` : 'the board';
  if (!where) return null;
  const lens: string[] = [];
  for (const t of v.tags ?? []) {
    const p = parseTag(t);
    if (p) lens.push(`${p.dimension.toLowerCase().replace(/_/g, ' ')}: ${p.value}`);
  }
  if (v.verified) lens.push(`validation: ${v.verified.toLowerCase().replace(/_/g, ' ')}`);
  if (v.sourced) lens.push(v.sourced === 'UNSOURCED' ? 'unsourced only' : 'sourced only');
  if (v.by) lens.push(`found by ${v.by}`);
  let out = where;
  if (lens.length) out += `, narrowed to ${lens.join(' and ')}`;
  if (v.drawer) out += `, with ${item(v.drawer)} open in the side panel`;
  return out;
}
